import { Component, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SessionListDataSource } from '@go-modules/services/session-list-datasource/session-list.datasource';
import { Session as SessionModel } from 'go-modules/models/session/session.service';
import { input } from '@angular/core';

@Component({
	selector: 'session-list-search-result-info',
	templateUrl: './session-list-search-result-info.component.html',
	styleUrls: ['./session-list-search-result-info.component.scss'],
	standalone: false
})
export class SessionListSearchResultInfoComponent {
	public readonly filteredSessions = input<ReturnType<typeof SessionModel>[]>();
	public readonly searchTerm = toSignal<string>(this.sessionListDataSource.textSearch$, { requireSync: true });
	private readonly dataSourceSessions = toSignal(this.sessionListDataSource.results$, { initialValue: [] });
	public readonly isLoading = toSignal(this.sessionListDataSource.loading$, { initialValue: false });
	public readonly displayedSessions = computed(() => {
		return this.filteredSessions() ?? this.dataSourceSessions();
	});

	constructor (
		public sessionListDataSource: SessionListDataSource
	) {}
}
